import { render, staticRenderFns } from "./DiseasesStatistics.vue?vue&type=template&id=125cd286&scoped=true&"
import script from "./DiseasesStatistics.vue?vue&type=script&lang=ts&setup=true&"
export * from "./DiseasesStatistics.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./DiseasesStatistics.vue?vue&type=style&index=0&id=125cd286&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125cd286",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('125cd286')) {
      api.createRecord('125cd286', component.options)
    } else {
      api.reload('125cd286', component.options)
    }
    module.hot.accept("./DiseasesStatistics.vue?vue&type=template&id=125cd286&scoped=true&", function () {
      api.rerender('125cd286', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town_translit]/vrach/[doctor_translit]/SectionPractice/common/DiseasesStatistics.vue"
export default component.exports